import React, { useState, useEffect, useMemo } from "react";
import styles from "./NewConnectionProfile.module.css";
import { apiUrl } from "../../Constants/Constants";
import { toast } from "react-toastify";
import { useFetchWithToken } from "../FetchWithToken/FetchWithToken";
import { AuthContext } from "../../Constants/AuthProvider";
import EachPackage from "./EachPackage.module";
import { toPersian } from "../../Utility/Utilities";
import Loading from "../Loading/Loading.module";
import { useNavigate } from "react-router-dom";
import CtaBtns from "../CtaBtns/CtaBtns.module";
function formatPrice(num) {
  try {
    return new Intl.NumberFormat("fa-IR").format(num) + " تومان";
  } catch {
    return num + " تومان";
  }
}

const NewConnectionProfile = ({ getInfo, loadingShow, setLoadingShow }) => {
  const [steps, setSteps] = useState(1);
  const navigate = useNavigate();
  const { loading, fetchWithToken } = useFetchWithToken();
  const { onLogout } = React.useContext(AuthContext);
  const [selectedId, setSelectedId] = useState(null);
  const [packages, setPackages] = useState([]);

  const selected = useMemo(
    () => packages?.find((p) => p.id === selectedId) || null,
    [packages, selectedId]
  );

  const [englishValue, setEnglishValue] = useState("");
  const [hadInvalidChar, setHadInvalidChar] = useState(false);

  const sanitizeEnglish = (s) => s.replace(/[^A-Za-z]/g, "");
  const handleEnglishChange = (e) => {
    const raw = e.target.value;
    const clean = sanitizeEnglish(raw);
    setHadInvalidChar(raw !== clean);
    setEnglishValue(clean);
  };
  useEffect(() => {
    setLoadingShow(loading);
  }, [loading]);
  const getPrices = () => {
    fetchWithToken(apiUrl + "user/packages", { method: "GET" }).then((data) => {
      if (data.status === "200") {
        const next = Array.isArray(data.data) ? data.data : [];
        setPackages(data.data);
      } else if (data.status === "6") {
        toast.error(data.data);
      } else if (data.status === "401") {
        onLogout();
      }
    });
  };
  const sendReserved = () => {
    const former = new FormData();
    former.append("accountName", englishValue);
    former.append("packageId", selected.id);

    fetchWithToken(
      apiUrl + "user/reserve-account",
      { method: "POST" },
      former
    ).then((data) => {
      if (data.status === "200") {
        const next = Array.isArray(data.data) ? data.data : [];
        if (typeof getInfo === "function") {
          getInfo();
        } else {
          navigate("/");
        }
      } else if (data.status === "6") {
        toast.error(data.data);
      } else if (data.status === "401") {
        onLogout();
      }
    });
  };
  useEffect(() => {
    steps == 1 && getPrices();
  }, [steps]);
  return (
    <div className={styles.addNewProfile}>
      {steps == 1 && (
        <div className={styles.totalCon}>
          <div className={styles.titleAddAccount}>
            <i className="fas fa-fa-solid fa-cart-plus"></i>
            انتخاب پروفایل جدید
          </div>
          <div className={styles.packages}>
            {packages?.map((pkg) => {
              const isActive = selectedId === pkg.id;
              return (
                <EachPackage
                  pkg={pkg}
                  isActive={isActive}
                  setSelectedId={setSelectedId}
                  onChange={(pkg) => {}}
                  formatPrice={formatPrice}
                  setSteps={setSteps}
                />
              );
            })}
          </div>
          {/* Selected summary */}
        </div>
      )}
      {steps == 2 && (
        <>
          {selected && (
            <>
              <div className={styles.totalCon}>
                <div className={styles.titleAddAccount}>
                  <i className="fas fa-fa-solid fa-cart-plus"></i>
                  ۲. تعیین نام اکانت
                </div>

                <div className={styles.partToAddInput}>
                  <div className={styles.inputEng}>نام اکانت*</div>
                  <input
                    className={styles.inputField}
                    type="text"
                    required
                    placeholder="حتما به زبان انگلیسی وارد شود"
                    value={englishValue}
                    onChange={handleEnglishChange}
                    lang="en"
                    dir="ltr"
                    inputMode="text"
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    pattern="[A-Za-z]{0,10}"
                    maxLength={10}
                  />
                  {hadInvalidChar && (
                    <p className={styles.errorin}>
                      فقط حروف انگلیسی (A–Z) مجاز است (بدون فاصله).
                    </p>
                  )}
                </div>
                <div className={styles.packageDetails}>
                  <div className={styles.titleChosed}>
                    انتخاب شما:
                    {selected.packageType == "Wireguard" && (
                      <img width="40" src="/asets/wireg.png" />
                    )}
                    {(selected.packageType == "Ovpn" ||
                      selected.packageType == "Ovpns") && (
                      <img width="40" src="/asets/ovp.svg" />
                    )}
                  </div>
                  <div className="text-sm text-gray-700">
                    <div className={styles.eachItem}>
                      نام پکیج:
                      <div className={styles.item}>{selected.name}</div>
                    </div>
                    <div className={styles.eachItem}>
                      قیمت:
                      <div className={styles.item}>
                        {formatPrice(selected.price)}
                      </div>
                    </div>
                    <div className={styles.eachItem}>
                      ترافیک
                      <div className={styles.item}>
                        {toPersian(selected.traffic)} گیگ
                      </div>
                    </div>
                    <div className={styles.eachItem}>
                      مدت زمان بسته
                      <div className={styles.item}>
                        {toPersian(selected.days)} روزه
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.descer}>
                  <i className="fa-light fa-exclamation-circle"></i>
                  با انتخاب "رزرو کن"، سفارش تا ۳۰ دقیقه برای شما محفوظ است و از
                  بخش اکانت های رزرو شده در صفحه اصلی می‌توانید پرداخت کنید.
                </div>
                <div className={styles.actions}>
                  <button className={styles.goback} onClick={() => setSteps(1)}>
                    بازگشت
                  </button>
                  <button
                    disabled={!englishValue}
                    className={styles.gonext}
                    onClick={() => sendReserved()}
                  >
                    رزرو کن
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
export default NewConnectionProfile;
